import { httpUrl } from "@/utils/httpUrl"

// Matches the legacy JDP implementation for consistent tracking behaviour.
export function generatePitchYouClickId(vanity: string, offerId: string): string {
  const timestamp = Date.now()
  const randomDigits = (crypto.getRandomValues(new Uint32Array(1))[0] % 90000) + 10000
  const safeVanity = vanity.replace(/\|/g, "")
  const safeOfferId = offerId.replace(/\|/g, "")
  return `${safeVanity}|${safeOfferId}|${timestamp}${randomDigits}`
}

/**
 * Writes the click id and the resolved applicant source onto a PitchYou apply
 * URL. Returns null when there is nothing to write or the URL cannot take it, so
 * the caller can hand back the job data untouched.
 *
 * The source is written as `utm_source` because that is the parameter PitchYou
 * prioritises, and it is overwritten here rather than forwarded: a Concludis
 * customer sends the real channel as `?quelle=4711` while Backoffice substitutes
 * its own default into `utm_source`, so without this the ATS records the JobShop
 * instead of the channel (JET-2719).
 *
 * The PitchYou link is the only place this happens. Every other outbound link and
 * the application payload forward what arrived, unchanged — widening it is an
 * open product question on JET-1643.
 */
export function buildPitchYouUrl(
  pitchYouUrl: string | undefined,
  { pyclid, source }: { pyclid?: string | null, source?: string | null },
): string | null {
  if (!pyclid && !source)
    return null

  const url = httpUrl(pitchYouUrl)

  if (!url)
    return null

  if (pyclid)
    url.searchParams.set("pyclid", pyclid)

  // Written independently of the click id: a job whose click id could not be
  // generated still has to carry the right source.
  if (source)
    url.searchParams.set("utm_source", source)

  return url.toString()
}
